import HelpService from './help.service'

export default {
  async openHelp () {
    // const helpRoute = router.resolve({ name: 'help' })
    // window.open(helpRoute.href)
    const helpUrl = window.location.origin + '/help'
    window.open(helpUrl, '_blank')
  },

  async helpData () {
    const response = await HelpService.queryHelp()
    return response
  }
}
